<!-- eslint-disable -->
<template>
  <v-container fluid class="caso-component">
    <v-data-table
      :headers="headers"
      :items="desserts"
      :loading="loading"
      class="elevation-1"
      no-data-text="Datos no disponibles"
      no-results-text="Sin resultados"
      :dense="true"
      fixed-header
      :height="500"
      :footer-props="{
        'show-current-page': false,
        'show-first-last-page': false,
        'items-per-page-options': [],
        'items-per-page-text': '',
      }"
      :disable-sort="true"
    >
      <template v-slot:top>
        <v-toolbar flat></v-toolbar>
      </template>
      <template v-slot:footer.page-text>
        <v-row justify="end" align="center" class="ma-0 pa-0">
          <v-col class="col-content-footer">
            <v-btn
              type="button"
              :loading="loading"
              :disabled="paginas.length === 0"
              @click="getDataAnterior"
              class="v-btn v-btn--icon v-btn--round v-btn--text theme--light v-size--default"
              aria-label="Previous page"
            >
              <span class="v-btn__content">
                <i aria-hidden="true" class="v-icon notranslate mdi mdi-chevron-left theme--light"></i>
              </span>
            </v-btn>
            <v-btn
              type="button"
              :loading="loading"
              :disabled="!ultimoDocumento"
              @click="getDataSiguiente"
              class="v-btn v-btn--icon v-btn--round v-btn--text theme--light v-size--default"
              aria-label="Next page"
            >
              <span class="v-btn__content">
                <i aria-hidden="true" class="v-icon notranslate mdi mdi-chevron-right theme--light"></i>
              </span>
            </v-btn>
          </v-col>
        </v-row>
      </template>
      <template v-slot:[`item.estado`]="{ item }">
        <v-chip small :color="chipColor(item.estado)" dark>{{ item.estado }}</v-chip>
      </template>
      <template v-slot:[`item.modificacion`]="{ item }">
        {{ formatFecha(item.modificacion) }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
/* eslint-disable */
import { db } from "../../firebase";
import moment from "moment";

export default {
  name: "VehiculosInmovilizados",
  data() {
    return {
      loading: true,
      unsubscribe: null,
      desserts: [],
      ultimoDocumento: null,
      primerDocumento: null,
      paginas: [],
      querySnapshot: null,
      headers: [
        { text: "# CASO", value: "caso" },
        { text: "PLACA", value: "placa" },
        { text: "ESTADO", value: "estado" },
        { text: "MODIFICACIÓN", value: "modificacion" },
      ],
    };
  },
  mounted() {
    this.getData();
  },
  beforeDestroy() {
    if (this.unsubscribe) this.unsubscribe();
  },
  methods: {
    getData() {
      try {
        this.loading = true;
        const consulta = db
          .collection("casos")
          .where("vehiculo_inmovilizado", "==", true)
          .orderBy("modificacion", "desc")
          .limit(10);
        if (this.unsubscribe) this.unsubscribe();
        this.unsubscribe = consulta.onSnapshot((querySnapshot) => {
          this.querySnapshot = querySnapshot;
          this.procesarQuerySnapshot();
        });
      } catch (error) {
        this.handleError(error);
      }
    },
    getDataSiguiente() {
      if (!this.ultimoDocumento) return;
      try {
        this.loading = true;
        const consulta = db
          .collection("casos")
          .where("vehiculo_inmovilizado", "==", true)
          .orderBy("modificacion", "desc")
          .limit(10)
          .startAfter(this.ultimoDocumento);
        if (this.unsubscribe) this.unsubscribe();
        this.unsubscribe = consulta.onSnapshot((querySnapshot) => {
          if (!querySnapshot.empty) {
            this.querySnapshot = querySnapshot;
            this.paginas.push(this.primerDocumento);
            this.procesarQuerySnapshot();
          } else {
            this.loading = false;
          }
        });
      } catch (error) {
        this.handleError(error);
      }
    },
    getDataAnterior() {
      if (this.paginas.length === 0) return;
      try {
        this.loading = true;
        const documentoAnterior = this.paginas.pop();
        const consulta = db
          .collection("casos")
          .where("vehiculo_inmovilizado", "==", true)
          .orderBy("modificacion", "desc")
          .limit(10)
          .startAt(documentoAnterior);
        if (this.unsubscribe) this.unsubscribe();
        this.unsubscribe = consulta.onSnapshot((querySnapshot) => {
          if (!querySnapshot.empty) {
            this.querySnapshot = querySnapshot;
            this.procesarQuerySnapshot();
          } else {
            this.loading = false;
          }
        });
      } catch (error) {
        this.handleError(error);
      }
    },
    procesarQuerySnapshot() {
      this.desserts = this.querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      this.ultimoDocumento =
        this.querySnapshot.docs[this.querySnapshot.docs.length - 1] || null;
      if (this.querySnapshot.docs.length < 10) {
        this.ultimoDocumento = null;
      }
      this.primerDocumento = this.querySnapshot.docs[0] || null;
      this.loading = false;
    },
    chipColor(estado) {
      const colores = {
        CERRADO: "error",
        Conciliado: "success",
        Cancelado: "secondary",
        "No conciliado": "warning",
      };
      return colores[estado] || "grey";
    },
    formatFecha(timestamp) {
      if (!timestamp) return "";
      try {
        return moment(timestamp.toDate()).format("YYYY-MM-DD HH:mm");
      } catch {
        return timestamp;
      }
    },
    handleError({ message }) {
      this.$swal({ icon: "error", title: "Error", text: message });
      this.loading = false;
    },
  },
};
</script>
